function toBoolean(value) {
    return ['true', '1'].includes(String(value).trim().toLowerCase());
}

export const isSkybetMigrationEnabled = toBoolean(window.isSkybetMigrationEnabled);

export const skybetApiName =
    isSkybetMigrationEnabled ? 'skybetflutter' : 'skybet';

export const skybetDiffusionName =
    window.skybetDiffusionName.toUpperCase();



// WEBPACK FOOTER //
// /src/js/common/utils/skybetMigration.js